var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-information-card"},[_c('h6',{staticClass:"personal-information-card__title"},[_vm._v(_vm._s(_vm.$t('Personal information')))]),(_vm.loadingAccount)?_c('div',{staticClass:"text-center py-5"},[_c('b-spinner')],1):_c('profile-form',{ref:"profileForm",attrs:{"account":_vm.account}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }